export default "__VITE_ASSET__4xWMf8dG__"